<template>
<div>
  <h4>Kontrahenci</h4>
  
  <form action="" class="form-horizontal" @submit.prevent="submit">
    <form-group label="Treść o kontrahentach" :error="errors['producerList.content']">
      <textarea-input v-model="producerList.content" rows="10"></textarea-input>
    </form-group>
  
    <br>
    <submit-button :submitting="submitting" class="pull-right"></submit-button>
    <br><br>
  </form>

  <router-link :to="getRouteToAdd" class="btn btn-primary">Dodaj kontrahenta</router-link>

  <br>
  <br>

  <table class="table table-striped table-bordered table-hover">
    <thead>
    <tr>
      <th>Nazwa</th>
      <th>Pozycja</th>
      <th></th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="(producer, index) in producers">
      <td>{{ producer.name }}</td>
      <td>
        <button
          class="btn btn-default btn-sm"
          v-show="index !== 0"
          @click.prevent="moveUp(producer)"
        >
          <span class="glyphicon glyphicon-chevron-up"></span>
        </button>

        <button
          class="btn btn-default btn-sm"
          v-show="index !== producers.length - 1"
          @click.prevent="moveDown(producer)"
        >
          <span class="glyphicon glyphicon-chevron-down"></span>
        </button>
      </td>
      <td>
        <router-link :to="getRouteToEdit(producer)" class="btn btn-default btn-sm">Edytuj</router-link>
        <question-button
          @click="remove(producer)"
          class="btn btn-danger btn-sm"
          question="Czy na pewno usunąć tego producenta?"
        >
          Usuń
        </question-button>
      </td>
    </tr>
    </tbody>
  </table>
</div>
</template>
<script>
import FormGroup from './FormGroup.vue'
import SubmitButton from './SubmitButton.vue'
import TextareaInput from './TextareaInput.vue'
import Api from './../api'
import QuestionButton from './QuestionButton.vue'
import Flash from './../Flash'

export default {
  data () {
    return {
      producers: [],
      producerList: {
        content: ''
      },
      submitting: false,
      errors: []
    }
  },
  components: {
    QuestionButton,
    SubmitButton,
    TextareaInput,
    FormGroup
  },
  methods: {
    submit () {
      this.errors = []
      this.submitting = true
      Api.producerList.put(this.producerList).then(this.onSubmitSuccess, this.updateError).then(() => { this.submitting = false })
    },
    onSubmitSuccess () {
      Flash.success('Zaktualizowano treść o kontrahentach')
    },
    updateError () {
      Flash.error('Niestety nie udało się zaktualizować treści o kontrahentach, skontaktuj się z administratorem')
    },
    moveUp (producer) {
      Api.producer.moveUp(producer.id).then(this.fetchData)
    },
    moveDown (producer) {
      Api.producer.moveDown(producer.id).then(this.fetchData)
    },
    remove (producer) {
      Api.producer.remove(producer.id).then(this.onRemoveSuccess(producer), this.onRemoveError)
    },
    onRemoveSuccess (producer) {
      return () => {
        this.producers.splice(this.producers.indexOf(producer), 1)
        Flash.success('Producent został poprawnie usunięty')
      }
    },
    onRemoveError () {
      Flash.error('Wystąpił nieoczekiwany błąd podczas usuwania producenta, skontaktuj się z administratorem')
    },
    getRouteToEdit (producer) {
      return {
        name: 'ProducerEdit',
        params: {
          id: producer.id
        }
      }
    },
    fetchData () {
      Api.producer.getList().then(this.fetchSuccess)
      Api.producerList.get().then(this.fetchContentSuccess)
    },
    fetchSuccess ({body}) {
      this.producers = body
    },
    fetchContentSuccess ({body}) {
      this.producerList = body
    }
  },
  computed: {
    getRouteToAdd () {
      return {
        name: 'ProducerAdd'
      }
    }
  },
  created () {
    this.fetchData()
  }
}
</script>



// WEBPACK FOOTER //
// Producers.vue?5724a8d6